import React from "react";
import "./index.scss";
import superagent from "superagent";
import { connect } from "react-redux";
import { renderIf } from "../../../../lib/util";
// import Button from "@material-ui/core/Button";
import Button from "@mui/material/Button";
import { authLoginRequest } from "../../../../action/auth-actions";

class PasswordReset extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      emailError: "",
      password: "",
      confirmPassword: "",
      success: false,
    };
  }

  componentDidMount() {
    this.setState({ success: false });
  }

  validEmail = email => {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(email)
  }

  handleChange = (e) => {
    this.setState({ loggedIn: false, emailError: "" });
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleBlur = () => {
    if (!this.validEmail(this.state.email))
      this.setState({ emailError: "Please enter a valid email address" });
    if (this.validEmail(this.state.email)) this.setState({ emailError: "" });
  };

  handlePasswordReset = (e) => {
    e.preventDefault();
    let url = window.location.href;
    let token = url.split("=")[1];

    this.setState({ emailError: "" });
    if (this.state.password.length < 7) {
      return this.setState({
        emailError: "Password must be at least 8 characters",
      });
    }

    if (!this.validEmail(this.state.email)) {
      return this.setState({
        emailError: "Please enter a valid email",
      });
    }

    if (this.state.password != this.state.confirmPassword) {
      return this.setState({
        emailError: "Password and verify password do not match",
      });
    }

    if (
      this.validEmail(this.state.email) &&
      this.state.password == this.state.confirmPassword
    ) {
      let pass = encodeURIComponent(this.state.password);
      superagent
        .put(`${__API_URI__}/password/update?token=${token}&password=${pass}`)
        .set("Content-Type", "application/json")
        .set("Platform", "Web")
        .set("Version", `${__version__}`)
        .end((err, res) => {
          if (err) {
            this.setState({ error: true });
            return;
          }
          this.setState({ password: "" });
          this.setState({ email: "" });
          this.setState({ emailError: "" });
          this.setState({ success: true }, () => {
            setTimeout(() => {
              window.location.href = __BASE_URL__;
              setTimeout(() => {
                this.props.returnToLogin?.();
              }, 1000);
            }, 10000);
          });

          // 	Do not redirect to store.
          // if (device.type == 'mobile') {
          // 	const userAgent = navigator.userAgent
          // 	if (userAgent.match(/iPhone/)) {
          // 		// 	window.location.href = 'IOS.APP.SCHEME://'
          // 		window.location.href = 'https://itunes.apple.com/us/app/basemap-own-the-outdoors/id1305237481?ls=1&mt=8'
          // 	} else if (userAgent.match(/Android/)) {
          // 		// 	window.location.href = 'ANDROID.APP.SCHEME://'
          // 		window.location.href = 'https://play.google.com/store/apps/details?id=com.mobile.basemap'
          // 	} else if (userAgent.match(/iPad|Macintosh/)) {
          // 		// 	window.location.href = 'IOS.APP.SCHEME://'
          // 		window.location.href = 'https://itunes.apple.com/us/app/basemap-own-the-outdoors/id1305237481?ls=1&mt=8'
          // 	} else {
          // 		// 	window.location.href = 'ANDROID.APP.SCHEME://'
          // 		window.location.href = 'https://play.google.com/store/apps/details?id=com.mobile.basemap'
          // 	}
          // 	setTimeout(() => {
          // 		this.props.returnToLogin()
          // 	}, 1000)
          // }
        });
    }
  };

  render() {
    const style = {
      marginTop: "20px",
      backgroundColor: 'rgb(88,149,0)',
      color: `#fff`,
    };

    return (
      <form className="password-reset-form">
        <h3>Password Reset</h3>
        {renderIf(
          this.state.error,
          <p>
            There was an error resetting your password. Please try again or
            contact us at support@basemap.com.
          </p>
        )}

        {renderIf(
          this.state.success,
          <p className="info">
            Password reset successful. Please log into your account.
          </p>,
          <React.Fragment>
            <p>{this.state.emailError}</p>
            <table className="password-reset-form__input">
              <tbody>
                <tr>
                  <td>Email</td>
                  <td>
                    <input
                      type="text"
                      name="email"
                      autoComplete="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      placeholder="customer@example.com"
                    />
                  </td>
                </tr>
                <tr>
                  <td>Password</td>
                  <td>
                    <input
                      type="password"
                      name="password"
                      value={this.state.password}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                    />
                  </td>
                </tr>
                <tr>
                  <td>Confirm Password</td>
                  <td>
                    <input
                      type="password"
                      name="confirmPassword"
                      value={this.state.confirmPassword}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                    />
                  </td>
                </tr>
              </tbody>
            </table>

            <Button
              variant="contained"
              color="primary"
              fullWidth
              style={style}
              onClick={(e) => this.handlePasswordReset(e)}
            >
              Update password
            </Button>
          </React.Fragment>
        )}
      </form>
    );
  }
}

const mapStateToProps = (state) => ({
  redirectToApp: state.redirectToApp,
});

const mapDispatchToProps = (dispatch) => ({
  authLoginRequest: (authObject) => dispatch(authLoginRequest(authObject)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PasswordReset);
